import type { ApiType } from 'types/api_type';

export const signateNotificationsApi: Readonly<ApiType> = {
  path: '/signate_notifications',
};

export const signateNotificationsUnSignedInPath = (): string => {
  return `${signateNotificationsApi.path}/un_signed_in`;
};

export const signateNotificationsSignedInPath = (): string => {
  return `${signateNotificationsApi.path}/signed_in`;
};
